import { ReactNode } from 'react';
import './PageCenterContainer.scss';

const PageCenterContainer = (props: {
  children: ReactNode;
}) => {
  return (
    <div className="page-center-container">
      <div className="page-center-content">
        { props.children }
      </div>
    </div>
  );
};

export default PageCenterContainer;
